var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 225,
    viewBox: "0 0 344 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6309 125.232C65.9827 123.196 65.2782 121.554 64.7181 120.367C64.0171 118.887 63.3548 117.507 62.1642 115.9C60.8996 114.192 60.1316 113.153 58.6557 112.392C56.7675 111.42 54.9393 111.532 54.108 111.596C52.4559 111.719 51.1455 112.342 48.5246 113.589C47.1473 114.245 47.7567 114.054 44.5371 115.742C43.6212 116.221 42.6278 116.732 41.4266 117.655C40.1056 118.669 39.5667 119.395 39.5138 120.208C39.4856 120.614 39.5913 120.909 39.6723 121.167C39.9506 122.03 40.2641 123.322 40.3909 125.154",
    fill: "#F8EC30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.167 125.711C336.871 120.575 337.301 116.478 337.766 113.629C338.446 109.468 339.203 107.982 338.365 105.731C337.107 102.37 333.539 100.669 330.351 99.1506C326.786 97.4527 325.902 97.9775 321.618 95.9203C320.442 95.3567 318.311 94.2612 315.876 92.5703C310.741 89.0055 310.836 87.3569 307.623 86.2296C305.206 85.3807 303.086 85.5885 300.204 85.8704C296.33 86.2473 293.427 87.4168 292.307 87.9029C289.851 88.9738 290.024 89.3648 286.804 90.8936C283.916 92.2639 282.468 92.9508 280.464 93.2854C276.673 93.9195 274.711 92.7465 273.524 94.1238C272.693 95.089 273.482 95.8675 272.686 97.4738C271.601 99.6578 269.568 99.369 267.782 101.303C266.835 102.328 266.458 104.195 265.75 107.883C265.327 110.081 264.841 112.639 264.594 116.256C264.432 118.617 264.355 121.621 264.594 125.109",
    fill: "#F8EC30"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.999 125.073C247.055 122.569 247.158 120.73 247.443 119.49C247.714 118.31 248.08 117.993 248.641 116.059C249.067 114.579 249.458 113.237 249.437 111.751C249.408 109.553 248.496 107.978 247.122 105.611C245.657 103.082 245.403 103.529 243.772 100.827C242.018 97.9175 242.089 97.0263 240.503 95.3249C239.168 93.8912 237.798 93.1057 237.153 92.771C236.364 92.3624 233.93 91.14 230.851 91.4148C228.865 91.5909 228.998 92.1792 225.508 92.9295C223.369 93.391 222.27 93.6164 220.801 93.4086C220.358 93.3452 219.685 93.2149 216.416 91.8129C213.872 90.7209 213.51 90.4707 212.668 90.1396C209.719 88.9807 206.982 89.2519 205.249 89.421C200.673 89.8719 199.965 91.5839 192.529 94.0074C189.352 95.0431 187.759 95.5609 186.428 95.5644C186.107 95.5644 185.216 95.5468 184.156 95.9237C184.156 95.9237 183.078 96.3077 182.123 97.1214C180.721 98.3156 180.334 110.254 181.405 126.553",
    fill: "#F8EC30"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.574 124.513C163.796 121.716 163.507 119.842 163.334 117.813C162.901 112.677 163.796 113.22 163.214 111.473C161.996 107.813 158.889 107.883 155.796 102.62C155.123 101.475 155.32 101.556 154.359 99.8691C152.389 96.4029 151.403 94.6698 149.575 93.4087C147.049 91.6685 144.242 91.6333 142.875 91.6157C140.596 91.5875 139.997 92.13 137.492 92.454C134.255 92.8697 131.786 92.4047 128.88 91.8552C123.24 90.7914 121.824 89.2555 118.47 89.8226C116.357 90.1784 114.162 91.0203 114.162 91.0203C112.683 91.5875 112.552 91.8059 111.291 92.3378C109.776 92.9719 106.99 94.1414 103.88 93.775C101.696 93.5179 99.4235 92.7993 98.1061 95.0819C95.3866 99.7916 95.1717 107.372 95.2598 112.677C95.4536 124.316 95.0837 124.376 95.6191 125.239C98.2329 129.463 106.557 127.215 118.351 126.556C141.568 125.26 161.893 131.037 163.334 126.556C163.436 126.236 163.482 125.665 163.574 124.524V124.513Z",
    fill: "#F8EC30"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6523 125.95C65.4199 125.197 65.0394 124.182 64.3948 123.08C63.0738 120.818 61.4499 119.539 60.9849 119.191C60.0056 118.451 58.1844 117.081 55.6024 116.859C54.1968 116.739 52.9498 117.098 50.4593 117.817C48.4831 118.387 47.1446 118.972 45.9715 119.49C42.463 121.044 41.9135 121.864 41.7233 122.181C40.9554 123.46 40.9448 124.975 40.9448 125.052C40.9448 125.623 41.0364 126.095 41.1244 126.43",
    fill: "#F8EC30"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.5583 69.0039H340.758V127.363H25.5583V69.0039Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.414 126.31C335.291 122.114 335.295 118.638 335.133 116.26C334.914 113.075 334.728 110.775 333.1 108.721C331.822 107.115 330.222 106.365 327.837 105.491C320.134 102.663 314.078 102.021 314.078 102.021C306.705 101.239 307.089 102.303 299.484 101.662C290.512 100.908 288.934 99.3407 285.605 100.943C281.839 102.758 282.981 105.188 277.707 108.362C275.189 109.88 271.976 111.099 269.929 112.91C269.725 113.093 268.577 114.122 266.939 115.421C266.266 115.953 265.995 116.147 265.861 116.26C264.871 117.081 264.219 119.324 265.741 125.591",
    fill: "#F8EC30"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.48 125.591C246.223 123.601 245.681 120.779 244.448 117.577C243.486 115.09 242.708 113.065 241.098 111.236C239.016 108.873 236.984 108.468 230.449 106.213C220.787 102.877 222.189 102.705 218.247 101.785C212.368 100.415 207.725 100.44 204.967 100.468C201.226 100.51 198.876 100.556 195.875 101.546C193.751 102.247 194.205 102.462 189.654 104.297C187.11 105.322 185.909 105.685 184.631 106.928C183.243 108.277 182.686 109.767 182.358 110.638C180.181 116.436 182.299 125.855 182.598 127.148",
    fill: "#F8EC30"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.258 124.992C161.803 123.361 161.127 121.392 160.106 119.25C159.82 118.655 158.77 116.496 156.755 113.628C153.487 108.975 151.852 106.65 149.097 105.85C147.84 105.488 146.505 105.488 143.835 105.491C140.668 105.495 140.485 105.889 139.051 105.611C136.166 105.054 136.247 103.342 133.069 102.141C130.618 101.215 128.307 101.38 126.01 101.542C125.08 101.609 123.875 101.824 121.462 102.261C116.083 103.23 116.267 103.455 114.882 103.459C111.057 103.469 110.394 101.764 108.182 102.5C106.882 102.934 107.249 103.476 103.754 107.048C101.975 108.869 101.408 109.207 98.8509 111.832C97.5898 113.128 96.9557 113.776 96.6985 114.104C95.7052 115.368 94.1094 118.528 96.6985 126.306",
    fill: "#F8EC30"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9157 44.3601V127.148H341.711V44.3601V0.810059",
    stroke: "white",
    strokeWidth: 3.52261,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M341.711 77.6167H321.854V69.0039H264.668V77.6167H244.328V69.0039H181.401V77.6167H160.582V69.0039H94.5436V77.6167H76.1203V69.0039H24.9157",
    stroke: "white",
    strokeWidth: 3.52261,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M264.588 127.148V78.6562",
    stroke: "white",
    strokeWidth: 3.52261,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M181.398 127.148V78.6562",
    stroke: "white",
    strokeWidth: 3.52261,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5449 127.148V78.6562",
    stroke: "white",
    strokeWidth: 3.52261,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M222.316 41.3691H69.7804",
    stroke: "#F8EC30",
    strokeWidth: 1.7613,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M339.799 127.863H266.462",
    stroke: "#F8EC30",
    strokeWidth: 5.28391,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M249.035 127.863H183.314",
    stroke: "#F8EC30",
    strokeWidth: 5.28391,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M164.334 127.863H96.5379",
    stroke: "#F8EC30",
    strokeWidth: 5.28391,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2285 127.863H39.6355",
    stroke: "#F8EC30",
    strokeWidth: 5.28391,
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.916 128.91V223.661H0.000609924",
    stroke: "#F8EC30",
    strokeWidth: 1.7613,
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1584 56.9214H92.6328V75.704H78.1584V56.9214Z",
    fill: "#17375E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M162.499 56.9214H179.566V75.704H162.499V56.9214Z",
    fill: "#17375E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M246.121 56.9214H262.871V75.9047H246.121V56.9214Z",
    fill: "#17375E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M323.049 56.9214H339.799V75.9047H323.049V56.9214Z",
    fill: "#17375E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.830eb5f9667a4d70c80407b5dba5a411.svg";
export { ForwardRef as ReactComponent };